import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

const BIOSPHERE_URL = "https://www.biospheresustainable.com/en/community/hotel-ciutat-martorell/8387";

/** Official Biosphere Sustainable Tourism certification seal, linking to the public profile.
 *  `onDark` = true when placed over a dark background (e.g. footer). */
export function BiosphereSeal({ onDark = false, className = "" }) {
  const { t } = useLang();
  const eyebrow = onDark ? "text-gold" : "text-terra";
  const strong = onDark ? "text-bone" : "text-charcoal";
  const body = onDark ? "text-bone/80" : "text-charcoal/70";
  const muted = onDark ? "text-bone/45" : "text-charcoal/45";
  const link = onDark ? "text-bone/60 group-hover:text-bone" : "text-charcoal/60 group-hover:text-charcoal";
  return (
    <a
      href={BIOSPHERE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="biosphere-seal"
      className={`group flex items-start gap-4 ${className}`}
    >
      <span className="shrink-0 rounded-md bg-bone p-2.5 border border-line">
        <img
          src="/images/biosphere/biosphere_vertical.svg"
          alt="Certificación Biosphere Sustainable Tourism · Hotel Ciutat Martorell"
          className="h-[68px] w-auto"
        />
      </span>
      <span className="text-xs leading-relaxed">
        <span className={`block font-mono text-[10px] uppercase tracking-[0.2em] ${eyebrow}`}>
          {t.pages.seal.sustainableTourism}
        </span>
        <span className={`mt-1 block ${body}`}>
          {t.pages.seal.certifiedBy} <strong className={`font-semibold ${strong}`}>Biosphere</strong>
        </span>
        <span className={`mt-0.5 block ${muted}`}>Cert. BHO 014/2026 BRT</span>
        <span className={`mt-1.5 inline-flex items-center gap-1 transition-colors ${link}`}>
          {t.pages.seal.viewCert} <ArrowUpRight size={11} />
        </span>
      </span>
    </a>
  );
}
